module.exports = __webpack_public_path__ + "img/support.1e0687ba.svg";